<template>
  <family-page-wrapper>
    <div class="col-md-12 no-padding-width">
      <div
        v-if="!mapUrl"
        class="error-message"
      >
        There is no active ride currently.
      </div>

      <h-t-m-l-loading-widget
        v-else
        id="live-map"
        :class="pageId"
        :file-name="mapUrl"
        :online="true"
        :height="600"
      />
    </div>
  </family-page-wrapper>
</template>

<script lang="ts">
import { ref, onMounted } from 'vue';
import { ElLoading } from 'element-plus';

import { useCustomer } from '@/use/customer';
import { rideService } from '@/services/ride';

import HTMLLoadingWidget from '../Operator/LoadingWidget/HTMLLoadingWidget.vue';

const pageId = 'live-ride-map';

export default {
  components: {
    HTMLLoadingWidget,
  },

  setup: () => {
    const { customerInfo } = useCustomer();

    const mapUrl = ref('');

    const getActiveRideInfo = async () => {
      if (!customerInfo.value?.id) {
        return;
      }

      const loading = ElLoading.service({
        lock: true,
        text: 'Loading Active Ride...',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'custom-full-spinner-class',
      });
      try {
        const response = await rideService.getActiveRide(customerInfo.value.id);
        mapUrl.value = response.gogoMap ?? '';
      } catch (error) {
        mapUrl.value = '';
      }
      loading.close();
    };

    onMounted(getActiveRideInfo);

    return {
      pageId,
      mapUrl,
    };
  },
};
</script>

<style lang="scss">
#live-ride-map {
  &.page-content {
    .error-message {
      font-size: 24px;
      padding-top: 30px;
    }
  }

  .live-ride-map {
    border: 1px solid #fbc0a4;
    margin-bottom: 20px;
  }
}
</style>
